import React from 'react';

import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { scan } from 'react-scan';

import { POSTHOG_HOST, POSTHOG_KEY } from '@/constants/env';

import App from './App';
import './index.css';

const root = createRoot(document.getElementById('root')!);
const renderApp = () => {
  const app = import.meta.env.DEV ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  );

  const hash = window.location.hash;
  let bootstrap = undefined;

  if (hash && hash.length > 1) {
    const params = new URLSearchParams(hash.substring(1));
    const distinctID = params.get('distinct_id');
    const sessionID = params.get('session_id');

    // Only set bootstrap if at least one ID is present
    if (distinctID || sessionID) {
      bootstrap = {
        ...(distinctID && { distinctID }),
        ...(sessionID && { sessionID })
      };
    }
  }

  if (POSTHOG_KEY && POSTHOG_HOST) {
    const providerOptions = {
      api_host: POSTHOG_HOST,
      ...(bootstrap ? { bootstrap } : {})
    };
    root.render(
      <PostHogProvider
        apiKey={POSTHOG_KEY}
        options={providerOptions}
      >
        {app}
      </PostHogProvider>
    );
  } else {
    root.render(app);
  }
};

if (import.meta.env.DEV) {
  scan({
    enabled: true
  });
  const { worker } = await import('../mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
  renderApp();
} else {
  renderApp();
}
